import {
  type AppBarProps,
  AppBar as MuiAppBar,
  Toolbar as MuiToolbar,
  type ToolbarProps,
} from '@mui/material';

export const AppBar = (props: AppBarProps) => <MuiAppBar {...props} />;
export const Toolbar = (props: ToolbarProps) => <MuiToolbar {...props} />;
